import React, { useEffect, useState } from "react";
import api from "../../api";
import IranFlag from "../../assets/images/iran.webp";
import { useParams } from "react-router-dom";
import Checkbox from '@material-ui/core/Checkbox';
import LoadingSpinner from "../Loading";
import {toast, ToastContainer} from "react-toastify";

function Release() {
    const [car, setCar] = useState(null);
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitActive, setIsSubmitActive] = useState(true);

    const handleCheckboxChange = (event) => {
        if (event.target.checked) {
            setIsSubmitActive(false);
            setStatus(4);
        } else {
            setStatus(null);
            setIsSubmitActive(true);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (status) {
            const requestBody = {
                'status': status
            }
            api.post(`/repair-request/status/${requestId}`, requestBody)
                .then(res => {
                    window.location.href = '/reports'
                })
                .catch(err => {
                    toast.error(err.response.data.message);
                })
        }
    };

    const { carId } = useParams();
    const { requestId } = useParams();

    useEffect(() => {
        async function fetchCar() {
            const response = await api.get(`/car/${carId}`);
            setCar(response.data.data);
        }
        fetchCar();

    }, []);


    return (
        <div>
            {isLoading ? <LoadingSpinner/> :
                <div className="content-wrapper">
                    <div className="container-xxl flex-grow-1 container-p-y">
                        
                        <div className="row justify-content-center g-0">
                            <div className="row w-auto pelak g-0 mb-3">
                                <div className="col">
                                    <div className="row my-auto">
                                        <div className="col border-start border-end-0">
                                            <p className="text-center fw-bold iranNo">ایران</p>
                                            <div>
                                                <p className="border-0 text-center">{car?.plate.slice(7, 9)}</p>
                                            </div>
                                        </div>
                                        <div className="col my-auto">
                                            <p className="border-0 text-center">{car?.plate.slice(3, 6)}</p>
                                        </div>
                                        <div className="col my-auto">
                                            <p className="border-0 text-center">{car?.plate.slice(2, 3)}</p>
                                        </div>
                                        <div className="col my-auto">
                                            <p className="border-0 text-center">{car?.plate.slice(0, 2)}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-auto leftSide">
                                    <div className="flag">
                                        <img src={IranFlag} alt="iran's flag"/>
                                    </div>
                                    <div className="iranText text-center">
                                        <p>I.R.</p>
                                        <p>IRAN</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                                        <div className="alert alert-info" role="alert">قبل از ترخیص خودرو در قسمت "آلبوم
                                            تصاویر بعد از تعمیرات" تصاویر را اضافه کنید <input
                                                type="submit"
                                                className="btn btn-sm btn-warning"
                                                name="submit"
                                                value="اضافه کردن عکس"
                                                onClick={() => {
                                                    window.location.href = `/album/${requestId}`
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="card rounded-4 border-2 border-dark mb-2">
                                    <h5 className="card-header text-center bg-dark text-white fw-bold">ترخیص خودرو</h5>
                                    <div className="card-body">
                                        <div className="mb-3">
                                            <label>
                                                <Checkbox checked={status === 4} onChange={handleCheckboxChange}/>
                                                آیا از ترخیص خودرو مطمین هستید ؟
                                            </label>
                                        </div>
                                        <form onSubmit={handleSubmit}>
                                            <div className="d-grid gap-2">
                                                <button disabled={isSubmitActive}  type="submit"
                                                        className="btn btn-primary">ثبت
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Release
